import React, { useEffect } from 'react';

interface GlobalLogoutListenerProps {
  onCustomLogout: () => void;
}

const GlobalLogoutListener: React.FC<GlobalLogoutListenerProps> = ({
  onCustomLogout,
}) => {
  useEffect(() => {
    const handleGlobalClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if the clicked element is an anchor tag with the logout onclick
      if (
        target.tagName === 'A' &&
        target.getAttribute('onclick')?.includes('/logout')
      ) {
        event.preventDefault();
        event.stopPropagation();
        onCustomLogout();
      }
    };

    // Add the global event listener
    document.addEventListener('click', handleGlobalClick, true);

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener('click', handleGlobalClick, true);
    };
  }, [onCustomLogout]);

  return null; // This component doesn't render anything
};

export default GlobalLogoutListener;
